import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetVacanciesQuery } from '../../../store/apis/administratives/vacancies';
import ContentHeader from '../../../components/ContentHeader';
import { Button, Table } from 'antd';
import queryString from 'query-string';
import useQueryString from '../../../hooks/useQueryString';
import { useNavigate } from 'react-router';
import routes from '../../../router/routes';

const List = () => {
  const [t, i18n] = useTranslation();
  const { page = 1, pageSize = 20, sort = '-id', ...restQuery } = useQueryString();
  const navigate = useNavigate();

  const {
    data: vacancies,
    isLoading: isVacanciesLoading,
    isFetching: isVacanciesFetching,
  } = useGetVacanciesQuery({ page, pageSize, sort, ...restQuery });

  const handlePageChange = useCallback((pagination) => {
    navigate({
      pathname: '',
      search: queryString.stringify({ page: pagination.current, pageSize: pagination.pageSize, ...restQuery }),
    })
  }, [navigate, restQuery]);

  const columns = useMemo(() => [
    {
      title: t('Порядковый номер'),
      dataIndex: 'orderId',
      key: 'orderId',
    },
    {
      title: t('Изображение'),
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (data) => (
        <img src={data} alt="" style={{ width: 150 }}/>
      ),
    },
    {
      title: t('Предмет'),
      dataIndex: 'subject',
      key: 'subject',
      render: (data) => (
        data?.name[i18n.language]
      )
    },
    {
      title: t('Опыт работы'),
      dataIndex: 'workExperience',
      key: 'workExperience',
      render: (data) => (
        data?.[i18n.language]
      )
    },
    {
      title: t('Уровень образования'),
      dataIndex: 'educationLevel',
      key: 'educationLevel',
      render: (data) => (
        data?.[i18n.language]
      )
    },
    {
      title: t('Кол-во часов преподавания'),
      dataIndex: 'tutoringHoursAmount',
      key: 'tutoringHoursAmount',
      render: (data) => (
        data?.[i18n.language]
      )
    },
    {
      title: t('Уровень дохода'),
      dataIndex: 'wageAmount',
      key: 'wageAmount',
      render: (data) => (
        data?.[i18n.language]
      )
    },
    {
      title: t('Опубликован?'),
      dataIndex: 'isPublic',
      key: 'isPublic',
      render: (isPublic) => (
        isPublic ? '✅' : '❌'
      )
    },
  ], [t, i18n]);

  return (
    <div>
      <ContentHeader title={t('Предметы преподавания')}>
        <Button
          type="primary"
          htmlType="button"
          onClick={() => {
            navigate(routes.vacancies('create'));
          }}
        >
          {t('Создать')}
        </Button>
      </ContentHeader>

      <Table
        rootClassName="overflow-scroll"
        columns={columns}
        loading={isVacanciesLoading || isVacanciesFetching}
        dataSource={vacancies?.results}
        rowKey="id"
        onChange={handlePageChange}
        onRow={(data) => ({
          onClick: () => {
            navigate(routes.vacancies(data.id));
          }
        })}
        pagination={{
          total: vacancies?.count,
          current: page,
          locale: { items_per_page: `/ ${t('на странице')}` },
          pageSize,
          showSizeChanger: true,
          showTitle: true,
          pageSizeOptions: [20, 50, 100],
        }}
      />
    </div>
  );
};

export default List;
